// import { isLengthLte, trim } from './utils'

let formatMoney = (amount: number) => {
  let amountStr = `${Math.ceil(amount)}`;
  return amountStr + ' ₽';

  // if (isLengthLte(3, amountStr)) return amountStr + ' ₽'
  //
  // let f = (x: string, y: string): string => {
  //   if (isLengthLte(3, x)) return x + ' ' + y + '₽'
  //   return f(x.slice(0, -3), x.slice(-3) + ' ' + y)
  // }
  // return trim(f(amountStr, ''))
}

export default formatMoney
